import { reducer as interfaceReducer } from 'shared/redux/interface'

import ORM from 'shared/lib/orm/orm'

import clientReducer from './client'
import settingsReducer from 'shared/redux/reducers/settings'
import filterReducer from './filter'
import itemsReducer from 'shop-components/redux/reducers/items'

const rootReducer = (state = {}, action) => ({
  orm: ORM.reducer(state.orm, action, state),

  client: clientReducer(state.client, action, state),
  interface: interfaceReducer(state.interface, action, state),
  settings: settingsReducer(state.settings, action, state),
  filter: filterReducer(state.filter, action, state),
  items: itemsReducer(state.items, action, state)
})

export default rootReducer
